import { useState } from "react";
import tw from "tailwind-styled-components";
import { FaUserTie } from "react-icons/fa";
import { BoxContainer } from "../../Components/Styles/PageStyles";
import ProfileBasicInfo from "../../Components/ProfileDetail/ProfileBasicInfo";
import ProfileLogo from "../../Components/ProfileDetail/ProfileLogo";

const ProfileDetail = () => {
    const [activeTab, setActiveTab] = useState("overview");
    const [apiData] = useState({
        name: "Anurag Singh",
        mobile: "9876543210",
        city: "Noida",
        regId: "KIP1001",
        status: 1,
        device: "Web",

        businessName: "Kipinn Technologies",
        businessAddress: "Sector 62, Noida, Uttar Pradesh",
        businessEmail: "info@kipinn.com",
        website: "https://kipinn.com",
        gstNo: "09ABCDE1234F1Z5",
        logo: "",
    });

    return (
        <BoxContainer>
            <PageWrapper>

                {/* ================= HEADER ================= */}

                <CardContainer>
                    <HeaderWrapper>
                        <ProfileWrapper>

                            <AvatarWrapper>
                                <IconWrapper>
                                    <FaUserTie
                                        className="text-primary-color"
                                        size={22}
                                    />
                                </IconWrapper>
                            </AvatarWrapper>

                            <ProfileInfo>
                                <div className="flex items-center gap-2">

                                    <ProfileName>
                                        {apiData.name}
                                    </ProfileName>

                                    <StatusBadge active={apiData.status === 1}>
                                        {apiData.status === 1 ? "Active" : "Inactive"}
                                    </StatusBadge>

                                </div>

                                <ProfileSubTitle>
                                    {apiData.businessEmail}
                                </ProfileSubTitle>

                            </ProfileInfo>

                        </ProfileWrapper>
                    </HeaderWrapper>

                    <CardBody>

                        <InfoGrid>

                            <InfoItem>
                                <InfoLabel>Registration ID</InfoLabel>
                                <InfoValue>
                                    #{apiData.regId}
                                </InfoValue>
                            </InfoItem>

                            <InfoItem>
                                <InfoLabel>City</InfoLabel>
                                <InfoValue>
                                    {apiData.city}
                                </InfoValue>
                            </InfoItem>

                            <InfoItem>
                                <InfoLabel>Mobile</InfoLabel>
                                <InfoValue>
                                    {apiData.mobile}
                                </InfoValue>
                            </InfoItem>

                            <InfoItem>
                                <InfoLabel>Gst Number</InfoLabel>
                                <InfoValue>
                                    {apiData.gstNo}
                                </InfoValue>
                            </InfoItem>

                        </InfoGrid>

                    </CardBody>
                </CardContainer>

                {/* ================= CONTENT ================= */}

                <MainContent>

                    <div className="mx-auto flex justify-between">

                        <TabContainer>

                            <Tab
                                active={activeTab === "overview"}
                                onClick={() => setActiveTab("overview")}
                            >
                                Overview
                            </Tab>

                            {/* <Tab
                                active={activeTab === "logo"}
                                onClick={() => setActiveTab("logo")}
                            >
                                Business Logo
                            </Tab> */}

                        </TabContainer>

                    </div>

                    <TabContent>

                        {activeTab === "overview" && (
                            <ProfileBasicInfo
                                apiData={apiData}
                                updateProfileLoading={false}
                                updateProfileMutate={(values) => console.log(values)}
                            />
                        )}

                        {activeTab === "logo" && (
                            <ProfileLogo apiData={apiData} />
                        )}

                    </TabContent>

                </MainContent>

            </PageWrapper>
        </BoxContainer>
    );
};

export default ProfileDetail;

/* ================= STYLES ================= */

const MainContent = tw.div`
p-3
rounded-lg
bg-white
shadow-sm
mt-6
`;

const TabContainer = tw.div`
flex
overflow-x-auto
gap-6
px-4
`;

const Tab = tw.button`
relative
px-1
py-3
text-sm
whitespace-nowrap
${({ active }) =>
        active
            ? "text-zinc-900 font-semibold border-b-2 border-zinc-900"
            : "text-zinc-500 hover:text-zinc-700"}
`;

const TabContent = tw.div`
pt-4
pb-6
px-4
`;

const CardContainer = tw.div`
bg-white
rounded-xl
shadow-sm
border
border-gray-200/60
overflow-hidden
`;

const HeaderWrapper = tw.div`
flex
items-center
gap-6
p-5
border-b
border-gray-100
`;

const ProfileWrapper = tw.div`
flex
items-center
gap-4
`;

const AvatarWrapper = tw.div`
flex
items-center
justify-center
w-12
h-12
`;

const IconWrapper = tw.div`
w-12
h-12
rounded-xl
bg-blue-50
flex
items-center
justify-center
`;

const ProfileInfo = tw.div`
flex-1
`;

const ProfileName = tw.h2`
text-md
font-semibold
text-gray-900
`;

const ProfileSubTitle = tw.p`
text-sm
text-gray-500
`;

const StatusBadge = tw.span`
px-2
py-1
text-xs
font-semibold
rounded-full
${({ active }) =>
        active
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-600"}
`;

const CardBody = tw.div`
p-5
`;

const InfoGrid = tw.div`
flex
flex-cols-1
md:flex-cols-2
lg:flex-cols-4
items-center
justify-between
`;

const InfoItem = tw.div``;

const InfoLabel = tw.div`
text-gray-500
text-sm
`;

const InfoValue = tw.p`
text-base
font-semibold
text-gray-900
`;

const PageWrapper = tw.div`
px-1
`;